function pad(n,l) {
  let str = ('' + n)
  if(typeof l == 'undefined') l = 2
  while(str.length < l) str = '0'+str
  return str
}

/*
1                 sekunda
2-4, 22-24, 32-34 sekundy
0, 5-21, 25-31    sekund
*/
function plural(value, singular, plural1, plural2) {
  if(value == 1) {
    return `${value} ${singular}`
  }
  else
  if(value == 0 || value >= 5 && value <= 21 || value >= 25 && (value % 10 >= 5 || value % 10 <= 1)) {
    return `${value} ${plural2}`
  }
  else {
    return `${value} ${plural1}`
  }
}

export default {
  pad,
  plural,
}